import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Wrapper, Loading } from './styled';
import { isClientEnv } from '@app/src/utils/validations';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';

const isClient = isClientEnv();

interface Props {
  className?: string;
}

export const CounterAvailable: React.FC<Props> = ({ className }) => {
  const [countByChannel, setCountByChannel] = useState(0);
  const [isResponsive, setIsResponsive] = useState(false);

  const typePayment = useSelector(state => state.session.user.pasarella);
  const availableData = useSelector(state => state.myPackageAvailable.data);
  const isLoading = useSelector(state => state.myPackageAvailable.isFetching);
  const printsByChannel = useSelector(state => state.print.printsByChannel);

  useEffect(() => {
    isClient && window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      isClient && window.removeEventListener('resize', handleResize);
    }
  }, []);

  const handleResize = () => {
    if (isClient && window.innerWidth > 1200) {
      setIsResponsive(false);
    } else {
      setIsResponsive(true);
    }
  };

  useEffect(() => {
    if (availableData && availableData.total) {
      const countByChannel = getPrintsSelects() || 0;
      setCountByChannel(countByChannel);
    }
  }, [printsByChannel, availableData]);

  const getPrintsSelects = () => {
    const currentData = printsByChannel && Object.keys(printsByChannel);
    const allChannel = [];
    if (currentData && currentData.length > 0) {
      currentData.map(item => {
        printsByChannel[item].map(el => {
          if (el) {
            allChannel && allChannel.push(el);
          }
        })
      })
      return allChannel && allChannel.length;
    }
  };

  return (
    <React.Fragment>
      {
        typePayment === 'consume-print' ?
          <Wrapper className={className} backgroundColor={(countByChannel !== 0) && '#FFD24D' || isResponsive && '#444' || '#fff'} color={(countByChannel !== 0) && COLORS.BLACK_BOLD || isResponsive && '#fff' || COLORS.BLUE_LINK}>
            Avisos Disponibles: {
              isLoading ?
                <Loading><Icon data-name='icon-circle' fill='#ccc' width="17" height="17" /></Loading>
                :
                <strong>{((availableData && availableData.total) - countByChannel) || 0}</strong>
            }
          </Wrapper> : null
      }
    </React.Fragment>
  )
};